import React from 'react'

const Cart = ({ width, height }) => {
  return (
    <div>
      <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14.9 14.9">
        <g transform="translate(-1.55 -1.55)">
          <path
            data-name="Path 945"
            d="m7.4 11.8 6.1-.509c1.91-.159 2.339-.576 2.55-2.481l.45-4.01M6 4.8h.7m10.5 0H6.7"
            transform="translate(-1.2)"
            style={{
              fill: 'none',
              stroke: '#b1b1b1',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '.9px',
            }}
          />
          <circle
            data-name="Ellipse 156"
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="translate(3 13)"
            style={{
              fill: 'none',
              stroke: '#b1b1b1',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '.9px',
            }}
          />
          <circle
            data-name="Ellipse 157"
            cx="1.5"
            cy="1.5"
            r="1.5"
            transform="translate(11 13)"
            style={{
              fill: 'none',
              stroke: '#b1b1b1',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '.9px',
            }}
          />
          <path
            data-name="Path 946"
            d="M6.2 14.6h4.9M2 2h.676a1.434 1.434 0 0 1 1.4 1.06l2.084 8.093a1.372 1.372 0 0 1-.245 1.18l-.671.867"
            style={{
              fill: 'none',
              stroke: '#b1b1b1',
              strokeLinecap: 'round',
              strokeLinejoin: 'round',
              strokeWidth: '.9px',
            }}
          />
        </g>
      </svg>
    </div>
  )
}

export default Cart
